import React from "react";

export type LoadingSpinnerSize = "small" | "medium" | "large";

interface LoadingSpinnerProps {}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = () => {
  return (
    <div className="text-center pt-12">
      <div className="p-5 pt-12 flex flex-col items-center gap-4">
        <div className="animate-spin rounded-full h-14 w-14 border-b-2 border-primary" />
        <span className="text-lg font-light text-primary">Please Wait..</span>
      </div>
    </div>
  );
};
export default LoadingSpinner;
